import classNames from 'classnames';
import React from 'react';
import styles from './badge_new.less';

interface BadgeNewProps {
  className?: string;
  size?: 'sm' | 'md';
}

export const BadgeNew = (props: BadgeNewProps) => {
  const { className, size } = props;
  return (
    <span
      className={classNames(styles.badge, className, {
        [styles.sm]: size === 'sm',
      })}
    >
      New
    </span>
  );
};
